import { REWARDS_DISCORD_URL } from './rewards';

export const faqItems = [
  {
    id: 'benefits', q: 'What benefits do I get?',
    a: 'Players using code GREENVENOM can access the following benefits, subject to eligibility:',
    details: [
      { label: 'Monthly leaderboards', text: '$25,000 in total prizes: $20,000 on the regular leaderboard and $5,000 on the Stake-exclusive slots board.' },
      { label: 'Weekly lossback', text: '10% back on eligible weekly losses on Stake.' },
      { label: 'Level-up rewards', text: 'Additional Stake level-up rewards from GreenVenom.' },
      { label: 'Welcome reload', text: 'The $21.00 reload offer for eligible players.' },
    ],
    paragraphs: ['You can also play Originals using virtual V credits.'],
    note: 'Additional ways to earn V credits and GV Store rewards are coming soon.',
    links: [{ label: 'View leaderboards', to: '/leaderboard' }, { label: 'Wager Rewards', to: '/rewards' }],
  },
  {
    id: 'lossback', q: 'How does the 10% weekly lossback work?',
    a: 'Eligible players using code GREENVENOM can receive 10% back on their eligible weekly losses on Stake.',
    details: [
      { label: 'Calculation', text: 'Lossback is calculated weekly.' },
      { label: 'Eligibility & claims', text: 'Current eligibility and claim requirements apply. See VIP Rewards for the offer details.' },
    ],
    links: [{ label: 'View VIP Rewards', to: '/vip-rewards' }],
  },
  {
    id: 'wager-rewards', q: 'How do Wager Rewards work?',
    a: 'When you level up on Stake, GreenVenom offers an additional payout on top of Stake’s own level-up reward.',
    paragraphs: ['Your eligible Stake level determines the bonus amount. Wager Rewards lists the available amounts, eligibility requirements and claim instructions.'],
    links: [{ label: 'Explore Wager Rewards', to: '/rewards' }],
  },
  {
    id: 'reload-bonus', q: 'How does the $21.00 reload bonus work?',
    a: 'Activate the $21.00 welcome reload offer in three steps:',
    steps: ['Create your Stake account using code GREENVENOM.', 'Deposit $5.00 into your Stake account.', 'Message Stake support to request activation of your $21.00 reload bonus.'],
    note: 'For eligible new accounts. Current offer terms apply.',
    links: [{ label: 'View bonus details', to: '/vip-rewards' }],
  },
  {
    id: 'originals', q: 'How do Originals work? Is it real money?',
    a: 'Originals are virtual-credit games, not real-money gambling. You play with V credits rather than real-life currency.',
    details: [
      { label: 'No cash value', text: 'V credits have no cash value and cannot be withdrawn as money.' },
      { label: 'No real-money bets', text: 'Playing Originals does not place real-money bets.' },
    ],
    links: [{ label: 'Explore Originals', to: '/originals' }],
  },
  {
    id: 'store-rewards', q: 'Can I claim extra rewards with V credits?', status: 'Coming soon',
    a: 'The planned GV Store will let you use V credits to claim rewards.',
    paragraphs: ['Shop redemption is not available yet. Reward options are being planned, with updates to be shared through community announcements.'],
  },
  {
    id: 'contact', q: 'How can I get in touch?',
    a: 'Join the GreenVenom Discord community and send GreenVenom a direct message.',
    paragraphs: ['Discord is the best place to ask about rewards, giveaways and upcoming features.'],
    links: [{ label: 'Join Discord', href: REWARDS_DISCORD_URL, discord: true }],
  },
  {
    id: 'earn-credits', q: 'How can I get V credits?',
    a: 'V credits can be awarded through community giveaways and Discord activities announced by GreenVenom.',
    details: [
      { label: 'Community campaigns', text: 'Join Discord to see available campaigns and ways to participate.' },
      { label: 'Video & stream rewards', text: 'Automated rewards for watching videos and streams are coming soon. These activities do not automatically credit V credits in the app yet.' },
    ],
    links: [{ label: 'Join the community', href: REWARDS_DISCORD_URL, discord: true }],
  },
];